<template>
  <div>
    <v-sheet>
      <div
        id="header"
        class="text-center"
        :class="!todaySchedule ? 'mb-4' : ''"
      >
        <div class="mb-3">
          <v-avatar color="#FAFAFA">
            <Icon
              :size="30"
              :color="'rgba(0,0,0,.54)'"
              :icon="'calendar-month-outline'"
            />
          </v-avatar>
        </div>
        <div>
          {{ widgetContent.title }}
        </div>
      </div>
      <div>
        <v-alert
          v-if="todaySchedule"
          class="my-3 py-2 px-0"
          elevation="0"
        >
          <div
            class="overline"
            style="font-family: 'Poppins', sans-serif !important;"
          >
            {{ widgetContent.description }}
          </div>
          <div class="d-flex text--secondary">
            <div class="mr-3">
              <Icon
                :size="30"
                :color="todaySchedule.attending ? '#4caf50' : '#b71c1c'"
                :icon="todaySchedule.attending ? 'calendar-check-outline' : 'calendar-remove-outline'"
              />
            </div>
            <div style="font-size: .875rem !important;">
              {{ todaySchedule.description }}
              <div
                v-if="todaySchedule.attending"
                class="d-flex caption mt-1"
              >
                <div>
                  <Icon
                    :size="30"
                    style="margin-bottom: 2px"
                    class="mr-2"
                    :color="'#fff'"
                    :icon="'clock-outline'"
                  />
                </div>
                <div class="font-weight-bold">
                  De {{ $ocularMoment.timeZoneDate(`${currentDate} ${todaySchedule.start_at}`).format('h:mm a') }}
                  a {{ $ocularMoment.timeZoneDate(`${currentDate} ${todaySchedule.end_at}`).format('h:mm a') }}
                </div>
              </div>
            </div>
          </div>
        </v-alert>
      </div>
      <v-divider></v-divider>
      <div id="content-tabs" class="mt-3">
        <p class="text--secondary text-center mb-2">
          {{ widgetContent.titleScheduleAttention }}
        </p>
        <v-tabs
          fixed-tabs
          v-model="selectedDay"
          show-arrows
          height="30"
        >
          <v-tab
            v-for="(dayOfWeek, index) in schedule"
            :key="`day-of-week-${index}`"
          >
            {{ dayOfWeek.day_of_week_es }}
          </v-tab>
        </v-tabs>
        <v-tabs-items
          v-model="selectedDay"
          class="mt-2"
        >
          <v-tab-item
            v-for="(dayOfWeek, index) in schedule"
            :key="`day-of-week-detail-${index}`"
            class="mx-5 my-2"
          >
            <v-timeline
              align-top
              dense
              class="ma-0 pa-0"
            >
              <v-timeline-item
                v-for="(item, index) in dayOfWeek.schedule"
                :key="`item-${index}`"
                :color="item.attending ? 'success' : 'error'"
                small
                class="pb-3"
              >
                <div class="text--secondary">
                  <div class="font-weight-normal" v-if="item.attending">
                    <small>
                      De <strong>{{ $ocularMoment.timeZoneDate(`${currentDate} ${item.start_at}`).format('h:mm a') }}</strong>
                      a <strong>{{ $ocularMoment.timeZoneDate(`${currentDate} ${item.end_at}`).format('h:mm a') }}</strong>
                    </small>
                  </div>
                  <div
                    style="line-height: 1; margin-top: 3px"
                  >
                    <small v-if="!item.attending && !item.description">
                      {{ widgetContent.noSchedule }}
                    </small>
                    <small>
                      {{ item.description }}
                    </small>
                  </div>
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-sheet>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'
require('@/plugins/OcularMoment')

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  computed: {
    widgetContent () {
      const config = this.$organization.widgetContent()

      return {
        title: config?.data?.lobby?.scheduled_organization?.title ?? config.defaultData.lobby.scheduled_organization.title,
        description: config?.data?.lobby?.scheduled_organization?.description ?? config.defaultData.lobby.scheduled_organization.description,
        titleScheduleAttention: config?.data?.lobby?.scheduled_organization?.title_schedule_attention ?? config.defaultData.lobby.scheduled_organization.title_schedule_attention,
        noSchedule: config?.data?.lobby?.scheduled_organization?.no_schedule ?? config.defaultData.lobby.scheduled_organization.no_schedule
      }
    }
  }
})
export default class Schedule extends Vue {
  data () {
    return {
      schedule: [],
      todaySchedule: null,
      currentDate: null,
      weekDays: [],
      weekDay: null,
      selectedDay: null
    }
  }

  mounted () {
    this.ocGoogleAnalyticsInit()
  }

  ocGoogleAnalyticsInit() {
    OcGoogleAnalytics.getDataLayerConfig('init')
  }

  created () {
    if (!this.$route.query.organizationSchedule) {
      return false
    }

    const date = new Date()
    const month = (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1)
    this.currentDate = `${date.getFullYear()} ${month} ${date.getDate()}`
    this.schedule = this.$route.query.organizationSchedule.schedule
    this.todaySchedule = this.$route.query.organizationSchedule.todaySchedule

    const weekday = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ]

    const currentDayIndex = date.getDay()
    const selectedWeekDay = weekday[currentDayIndex]
    const selectedDayIndex = this.schedule.findIndex((weekDay) => weekDay.day_of_week_en === selectedWeekDay)

    this.selectedDay = selectedDayIndex >= 0 ? selectedDayIndex : 0
  }
}
</script>

<style>
#title {
  font-size: .875rem;
  padding: 15px 0px 15px 0px;
  color: #0074c8;
}

.hours{
  font-size: 0.83em;
  padding: 1px 0px 10px 25px;
  background:#faf9f9;
}

.outhours{
 font-size: 0.83em;
 color:rgba(0,0,0,.6)!important;
 margin:20px 20px 20px 20px;
}

div.v-timeline-item__divider {
  /* min-width: 20px !important; */
}
</style>





